import { Component, OnInit } from '@angular/core';
import { PrivateSectorService } from 'src/app/services/private-sector.service';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-private-sector-sc-content',
  templateUrl: './private-sector-sc-content.component.html',
  styleUrls: ['./private-sector-sc-content.component.css']
})
export class PrivateSectorScContentComponent implements OnInit {

  items$
  subcategory

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private service: PrivateSectorService
  ) { 
    
  }

  ngOnInit() {
    var id = this.route.snapshot.paramMap.get('id');
    this.service.getSubCategory(id).subscribe(res => this.subcategory = res);
    this.items$ = this.service.getItems(id).pipe(
      map(changes => 
        changes.map(c => ({ key: c.payload.key, ...(c.payload.val() as object) }))
      )
    );
  }

  deleteItem(number: string, name: string) {
    if(confirm("Confirmar la eliminación del número " + number + " de " + name )) {
      this.service.deleteItem(number);
    }
  }


}
